<template>
    <button v-if="type === 'link'"  class="link tree-button" :data-url="jsonPath">
        <span>{{ label ?? $t('common.edit') }}</span>
    </button>
    <button v-else-if="type === 'action-button'" :data-url="jsonPath">
        <i :class="['mdi', icon]"></i>
        <span>{{ label ?? $t('common.edit') }}</span>
    </button>
    <button v-else :class="[type, 'tree-button']" :data-url="jsonPath">
        <i :class="['mdi', icon]"></i>
        <span :class="color">{{ label ?? $t('common.edit') }}</span>
    </button>
</template>

<script>
export default {
    name: "TreeButton",
    props: {
        path: {
            type: Object,
            required: true
        },
        label: {
            type: String,
            default: null
        },
        type: {
            type: String,
            default: "btn btn-sm btn-light border edit-button"
        },
        icon: {
            type: String,
            default: "mdi-pencil"
        },
        color: {
            type: String,
            default: "d-none d-sm-inline ms-1"
        },
    },
    computed: {
        jsonPath() {
            return JSON.stringify(this.path);
        }
    }
};
</script>

<style scoped>
.tree-button {
    display: inline-block;
}
.link {
    background: none;
    border: none;
    color: inherit;
    padding: 0;
    font: inherit;
}
</style>

